<template>
	<module-tab name="未分类商品" enable-flex @mounted="searchHandle" @activated="update">
		<m-search ref="search" @search="searchHandle">
			<m-search-item label="商品标题">
				<c-input name="product_name"></c-input>
			</m-search-item>
<!--			<m-search-item label="SKU编码">
				<c-input name="product_sku_code"></c-input>
			</m-search-item>-->
			<m-search-item label="创建时间" colspan="2">
				<c-datetime start-name="start_date" end-name="end_date" range></c-datetime>
			</m-search-item>
		</m-search>
		
		<m-operate>
			<c-button @click="editGroup()">批量归属分类</c-button>
		</m-operate>
		
		<c-table ref="table" height="grow">
			<c-table-column
				type="selector"
			></c-table-column>
			
			<c-table-column
				label="商品信息"
				width="300"
			>
                <template #default="{data}">
                    <product-info v-if="data.product_itemnumber" :image="data.product_img_url" :name="data.product_itemnumber + ' - '+data.product_name"></product-info>
                    <product-info v-else :image="data.product_img_url" :name="data.product_name"></product-info>
                </template>
			</c-table-column>
			
			<c-table-column
				label="价格"
				width="130"
				name="product_price"
			></c-table-column>
			
			<c-table-column
				type="button"
				label="操作"
				width="170"
			>
				<template #default="{data}">
					<c-table-button @click="editGroup(data)">归属分类</c-table-button>
					<c-table-button v-if="auth('b_product_edit')" @click="navigateTo(`/product_edit/${data.product_id}`)">编辑</c-table-button>
				</template>
			</c-table-column>
		</c-table>
		
		<group-edit ref="editGroup" @resolve="$refs.table.update()"></group-edit>
	</module-tab>
</template>

<script>
	import productInfo from '@/components/public/product_info.vue'
	import groupEdit from './product_group_edit.vue'
	
	export default {
		components: {
			productInfo,
			groupEdit
		},
		
		data() {
			return {
				groupList: []
			}
		},
		
		methods: {
			update() {
				this.$refs.editGroup.update();
				this.$refs.table.update();
			},
			
			searchHandle(data = {}) {
				data.un_product_group = 1;
				this.$refs.table.load({
					url: '/product/list',
					data
				});
			},
			
			editGroup(item) {
				var list = item ? [{
					data: item
				}] : this.$refs.table.getRow('selected');
				
				this.$refs.editGroup.open(Array.from(list, item => item.data.product_id));
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>
